export function capitalizeTitle(string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase()
}
